<template>
  <div class="pagination-wrapper" v-if="totalPage">
    <el-pagination
      :hide-on-single-page="singlePageShow"
      background
      @current-change="handleCurrentChange"
      :current-page.sync="currentPageNum"
      next-text="下一页"
      layout="pager, next, slot, jumper"
      :page-size="pageSize"
      :total="total"
      :lastPage='totalPage'
      >
      <span>
        <el-button 
          :disabled="currentPageNum === totalPage"
          class="last-pager"
          @click="toLastPage"
          >尾页</el-button>
      </span>
      <span class="totalPage">共{{totalPage}}页</span>
    </el-pagination>
  </div>
</template>

<script>
export default {
  name: 'Pagination',
  data () {
    return {
      currentPageNum: this.currentPage,
      firstPageBtnDisabled: true,
      lastPageBtnDisabled: false,
      //lastPageNum: Math.ceil(this.total / this.pageSize)
    }
  },
  props: {
    currentPage: {
      type: Number,
      default: 1
    },
    pageSize: {
      type: Number,
      default: 15
    },
    total: {
      type: Number,
      //default: 50
      default: 50
    },
    totalPage: {
      type: Number,
      default: 0
    }
  },
  computed: {
    singlePageShow () {
      return this.totalPage > 0 ? true : false
    }
  },
  watch: {
    // 监听页码
    '$route.query.pageNo'() {
      this.currentPageNum = parseInt(this.$route.query.pageNo, 10);
    }
  },
  created() {
    this.currentPageNum = parseInt(this.$route.query.pageNo, 10);
  },
  methods: {
    handleCurrentChange(val) {
      this.firstPageBtnDisabled = val === 1 ? true : false;
      this.lastPageBtnDisabled = val === this.totalPage ? true : false;
      this.currentPageNum = val;
      this.$emit("handleCurrentChangeSub", val);
      //this.$router.push({path: '/search', query: {keyword: window.escape(queryInfo)}})
      this.$store.dispatch('saveCurrentPage', val)
    },
    toLastPage(val) {
      this.currentPageNum = this.totalPage;
      this.handleCurrentChange(this.totalPage);
    }
  },
  created() {},
  mounted() {},
  destroyed() {}
}
</script>

<style lang="less" scoped>
  /* 页码样式 */
.pagination-wrapper {
  position: relative;
  width: 1200px;
  margin: 0 auto;
  height: 120px;
  .el-pagination{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate3d(-50%,-50%,0);
  }
  /deep/ .el-pagination__editor.el-input {
    width: 50px;
    margin: 0 6px;
  }
  /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #c4a08d;
    color: #fff;
  }
  /deep/ .el-pagination.is-background .el-pager li {
    color: #94491f;
    background: #f2eeeb;
    min-width: 30px;
    border: 1px solid #c4a08d;
    padding: 0 4.5px;
    border-radius: 1px;
  }
  /deep/ .el-pagination.is-background .btn-next {
    width: 62px;
    height: 30px;
    border: 1px solid #c4a08d;
    color: #94491f;
  }
  /deep/ .el-pagination__editor.el-input .el-input__inner {
    width: 50px;
    height: 30px;
    border: 1px solid #ddd;
  }
  .last-pager {
    width: 50px;
    height: 30px;
    border: 1px solid #c4a08d;
    color: #94491f;
    text-align: center;
    background: #f2eeeb;
    cursor: pointer;
  }
  .totalPage, .el-pagination__jump {
    color: #333;
    font-size: 14px;
    font-weight: 500;
  }
  /deep/ .el-pagination__jump {
    color: #333;
    margin-left: 18px;
  }
}

</style>



// WEBPACK FOOTER //
// src/common/Pagination.vue